import { useState } from "react";
import { featuredThreads } from "@/mocks/gossip";
import SectionTitle from "./SectionTitle";

function toneClass(tag: string) {
  if (tag === "沸点") return "bg-primary-500 text-background-50";
  if (tag === "蹲") return "bg-accent-500 text-foreground-950";
  return "bg-secondary-500 text-background-50";
}

export default function FeaturedZone() {
  const [watched, setWatched] = useState<Record<string, boolean>>({});

  return (
    <section id="rank" className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-12">
      <SectionTitle
        eyebrow="封面热瓜"
        title="热度抢鲜 · 大瓜精选"
        desc="封面驱动的热帖直通车，点进封面即可进入对应蹲帖楼层"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {featuredThreads.map((t, i) => {
          const active = !!watched[t.title];
          return (
            <article
              key={t.title}
              className="group animate-float-up overflow-hidden rounded-lg border border-background-200 bg-background-100 transition hover:border-primary-200"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <a href="#feed" className="relative block aspect-[16/10] w-full overflow-hidden">
                <img
                  src={t.cover}
                  alt={`${t.title}封面`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className={"absolute left-3 top-3 rounded px-2 py-0.5 text-xs font-semibold " + toneClass(t.tag)}>
                  {t.tag === "沸点" ? "沸" : t.tag}
                </span>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded bg-foreground-950/55 px-2 py-0.5 text-[11px] text-white backdrop-blur">
                  {t.category}
                </span>
              </a>
              <div className="p-4 md:p-5">
                <a href="#floor" className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 hover:text-primary-700 md:text-lg">
                  {t.title}
                </a>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{t.excerpt}</p>
                <div className="mt-4 flex flex-wrap items-center justify-between gap-2 border-t border-background-200 pt-3">
                  <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1"><i className="ri-stack-fill text-primary-600"></i>{t.floor} 楼</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{t.followers} 在蹲</span>
                    <span className="hidden items-center gap-1 text-secondary-700 sm:inline-flex"><i className="ri-time-line"></i>{t.time}</span>
                  </div>
                  <button
                    onClick={() => setWatched((s) => ({ ...s, [t.title]: !s[t.title] }))}
                    className={
                      "inline-flex items-center whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs font-medium transition " +
                      (active
                        ? "bg-secondary-500 text-background-50"
                        : "bg-background-200 text-foreground-700 hover:bg-secondary-200 hover:text-secondary-900")
                    }
                  >
                    <i className={"mr-1 text-xs " + (active ? "ri-check-line" : "ri-add-line")}></i>
                    {active ? "已在蹲" : "蹲帖"}
                  </button>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}